import { ChildProps } from '@/common/util/props'

const GuidanceAreaContent = ({ children }: ChildProps) => {
  return (
    <div className='flex h-full min-h-110 flex-col items-center justify-center gap-6 p-10'>
      {children}
    </div>
  )
}

export default GuidanceAreaContent
